import moment from "moment";
import { ATTENDANCE_ACTIVITY } from "../../redux/constants/actvityType";

export const extractClockInOutTimes = (activityArray, shiftDuration = 0) => {
  if (!Array.isArray(activityArray) || activityArray.length === 0) {
    return {
      firstClockIn: "-",
      lastClockOut: "-",
      durationMinutes: 0,
      durationHours: "0.00",
      remainingMinutes: shiftDuration * 60,
      remainingHours: shiftDuration.toFixed(2),
    };
  }
const CLOCK_IN = ATTENDANCE_ACTIVITY.CLOCK_IN;
const CLOCK_OUT = ATTENDANCE_ACTIVITY.CLOCK_OUT;
  const clockIns = activityArray
    .filter((act) => Number(act.activity_type) === Number(CLOCK_IN) && act.time)
    .map((act) => act.time)
    .sort();

  const clockOuts = activityArray
    .filter((act) => Number(act.activity_type) === Number(CLOCK_OUT) && act.time)
    .map((act) => act.time)
    .sort();

  let durationMinutes = 0;

  const sortedActivities = [...activityArray].sort((a, b) =>
    moment.utc(a.time).diff(moment.utc(b.time))
  );

  for (let i = 0; i < sortedActivities.length - 1; i++) {
    const curr = sortedActivities[i];
    const next = sortedActivities[i + 1];
    if (
      curr.activity_type === 1 &&
      next.activity_type === 2 &&
      curr.time &&
      next.time
    ) {
      const start = moment.utc(curr.time);
      const end = moment.utc(next.time);
      if (end.isAfter(start)) {
        durationMinutes += end.diff(start, "minutes");
      }
    }
  }

  const firstClockIn =
    clockIns.length > 0
      ? moment.utc(clockIns[0]).format("hh:mm A")
      : "-";

  const lastClockOut =
    clockOuts.length > 0
      ? moment.utc(clockOuts[clockOuts.length - 1]).format("hh:mm A")
      : "-";

  const shiftMinutes = shiftDuration * 60;
  const remainingMinutes = Math.max(shiftMinutes - durationMinutes, 0);

  return {
    firstClockIn,
    lastClockOut,
    durationMinutes,
    durationHours: (durationMinutes / 60).toFixed(2),
    remainingMinutes,
    remainingHours: (remainingMinutes / 60).toFixed(2),
  };
};
